<template>
  <div class="survey-error-page">
    <div class="center-wrapper">
      <div class="head-color-bar" :style="{ backgroundColor: company.custom_color }"></div>
      <div class="company-logo">
        <img :src="company.logo"/>
      </div>
      <div class="tip-msg">
        <p v-if="errorType === '20002006'" >{{ $t('error.page.noAccessToComapnySurvey.notCompanyEmployee', { companyName }) }}</p>
        <p v-if="errorType === '20002007'" >{{ $t('error.page.noAccessToComapnySurvey.employeeNoPass') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      company: {}
    }
  },
  computed: {
    companyId () {
      return this.$route.query.companyId
    },
    errorType () {
      return this.$route.query.type
    },
    companyName () {
      const isEn = this.$i18n.locale === 'en'
      return isEn ? this.company.name : this.company.cn_name
    }
  },
  created () {
    this.initSiteData()
  },
  methods: {
    ...mapActions('company', ['getCompanyBaseInfo']),
    async initSiteData () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getCompanyBaseInfo({ id: this.companyId, params: { simple_info: 1 } })
        if (resp) {
          this.company = resp
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.survey-error-page {
  display: flex;
  height: 100vh;
  width: 100vw;
  background: #000;

  .center-wrapper {
    flex: 1;
    margin: 10% 7% auto;
    padding-bottom: 80px;
    background: #fff;

    .head-color-bar {
      height: 15px;
    }

    .company-logo {
      img {
        display: block;
        width: 150px;
        height: 150px;
        margin: 0px auto;
      }
    }

    .tip-msg {
      margin: 10px 20px;
      text-align: center;
    }
  }
}
</style>
